export default {
  endpoints: {
    confirm: '/accounts/confirm/email',
    resend: '/accounts/confirm/email/resend',
    unsubscribe: '/accounts/preferences/unsubscribe'
  }
}
